import { render, staticRenderFns } from "./SignatoryCreditInfo.vue?vue&type=template&id=1b2ccba4"
import script from "./SignatoryCreditInfo.vue?vue&type=script&lang=js"
export * from "./SignatoryCreditInfo.vue?vue&type=script&lang=js"
import style0 from "./SignatoryCreditInfo.vue?vue&type=style&index=0&id=1b2ccba4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports